"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormFieldWrapper = _interopRequireDefault(require("../FormFieldWrapper/FormFieldWrapper"));

var _keyHelpers = require("../../utils/keyHelpers");

var _DateFields = _interopRequireDefault(require("./DateFields"));

var _dateConfig = require("./dateConfig");

var _validation = require("../../types/validation");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var DateDefinition = _flowRuntime["default"].tdz(function () {
  return _dateConfig.DateDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("date", _flowRuntime["default"].ref(DateDefinition)), _flowRuntime["default"].property("parentKey", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true)));

var Date = function Date(_arg) {
  var date = _arg.date,
      parentKey = _arg.parentKey,
      inheritedFieldValidation = _arg.inheritedFieldValidation;
  var componentKey = (0, _keyHelpers.compositeKey)(parentKey, date.key);
  var noMargin = date.ui && date.ui.noMargin;
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    id: componentKey,
    className: noMargin ? 'fieldset--no-margin' : undefined
  }, /*#__PURE__*/_react["default"].createElement(_FormFieldWrapper["default"], {
    field: date,
    renderField: function renderField(_ref) {
      var input = _ref.input,
          inputStyle = _ref.inputStyle,
          isRequired = _ref.isRequired,
          error = _ref.meta.error;
      return /*#__PURE__*/_react["default"].createElement(_DateFields["default"], {
        component: _DateFields["default"],
        date: date,
        day: _dateConfig.day,
        error: error,
        key: date.key,
        input: input,
        inputStyle: inputStyle,
        isRequired: isRequired,
        month: _dateConfig.month,
        name: date.key,
        parentKey: parentKey,
        type: "date",
        year: _dateConfig.year
      });
    },
    inheritedFieldValidation: inheritedFieldValidation
  }));
};

Date.defaultProps = {
  parentKey: undefined,
  inheritedFieldValidation: []
};
var _default = Date;
exports["default"] = _default;